export default {
  infoQr: {
    aprobaciones: [],
    dnt: {},
    firmas: [],
    privado: '',
    url: ''
  }
};
